import { Map, OrderedMap, fromJS } from "immutable";
import { APP_REHYDRATE } from "../components/App/AppRehydrate";

export type ReducerState =
    | ReturnType<typeof OrderedMap>
    | ReturnType<typeof Map>;
export type OptionsType = "Map" | "OrderedMap";
interface Options {
    type?: OptionsType;
    transformRehydrate?: any;
}
export type InitialState = Record<string, any>;

export interface Action<T> {
    type: string;
    payload: T;
}
export type FnMap = Record<
    string,
    (state: ReducerState, action: Action<any>) => ReducerState
>;

export interface SagaAction {
    payload: any;
}

export function actionType(type: string) {
    return function actionTypeInner(payload: any): Action<typeof payload> {
        return { type, payload };
    };
}

function stateWrapper(
    options: Options,
    initialState: InitialState
): ReducerState {
    if (!!options && options.type === "OrderedMap") {
        return OrderedMap(initialState);
    }

    return Map(initialState);
}

export function reducerFn(
    name: string,
    initialState: InitialState,
    fnMap: FnMap,
    options: Options = {}
) {
    return function reducerFnInner(
        state = stateWrapper(options, initialState),
        action: Action<any>
    ) {
        const { type, payload } = action;

        if (fnMap[type]) {
            return fnMap[type](state, action);
        }

        if (!payload) {
            return state;
        }

        if (type === APP_REHYDRATE && name === payload.name) {
            if (options && options.transformRehydrate) {
                return state.merge(options.transformRehydrate(payload.value));
            } else {
                return state.merge(fromJS(payload.value));
            }
        }

        return state;
    };
}
